"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albino": {
    "6ea65207": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bondo-petello": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "albino"
    }],
    "comenduno": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "albino"
    }],
    "3068a9b0": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "desenzano-al-serio": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "albino"
    }],
    "0912c82a": [{
      "hkey": "ad4fd22a",
      "slug": "dossello-gavazzuolo",
      "name": "Dossello-Gavazzuolo",
      "primary": true,
      "skipSearch": false
    }],
    "dossello": [{
      "hkey": "ad4fd22a",
      "slug": "dossello-gavazzuolo",
      "name": "Dossello-Gavazzuolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2aa78bde": [{
      "hkey": "ff6cb51f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;